import { Combobox } from '@/components/common/Combobox'
import { useTeams } from '@/features/admin/teams/hooks'
import type { Team } from '@/features/admin/teams/types'

interface TeamComboboxProps {
  value: number | null
  onChange: (team: Team | null) => void
}

/**
 * Combobox pokazujący wszystkie aktywne zespoły. Polityka delegacji 2026-05-28:
 * każdy zalogowany może delegować do dowolnego zespołu (klient: "wszystkie zespoły
 * dla każdego"). Cross-team restriction ewentualnie dorobimy później per permission
 * (`tasks.assign.cross-team`) - patrz Obsidian Follow-ups/Task edit permissions.
 *
 * Wcześniej: useMyTeams() ograniczał do zespołów członkowskich (F2A "team tylko swój").
 */
export function TeamCombobox({ value, onChange }: TeamComboboxProps) {
  const { data: teams = [], isLoading } = useTeams(true)

  if (isLoading) {
    return <div className="text-sm text-muted-foreground">Ładowanie zespołów…</div>
  }
  if (teams.length === 0) {
    return <div className="text-sm text-muted-foreground">Brak aktywnych zespołów.</div>
  }

  return (
    <Combobox<number>
      value={value}
      onChange={(id) => {
        if (id == null) {
          onChange(null)
          return
        }
        const team = teams.find((t) => t.id === id) ?? null
        onChange(team)
      }}
      options={teams.map((t) => ({ value: t.id, label: t.name }))}
      placeholder="-- wybierz zespół --"
    />
  )
}
